<template>
    <CButton
      size="sm"
      color="primary"
      class="pl-3 pr-3 see-all-link"
      @click="toPage"
    >See all</CButton>
</template>
<script>
export default {
  name: 'VSeeAllLink',

  props: {
    to: {
      type: String,
      required: true
    }
  },

  methods: {
    toPage () {
      this.$router.push(this.to)
    }
  }
}
</script>
